import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as UnitActionCreators from '../../actions/unit'

import UnitAdmin from './UnitAdmin'

class UnitAdminContainer extends React.Component {
  static propTypes = {
    units: PropTypes.object.isRequired,
    unitActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      units: state.units,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.props.unitActions.listUnits()
  }

  render() {
    const { units, unitActions } = this.props

    return (
      <UnitAdmin
        units={units}
        onCreateUnit={unitActions.addUnit}
        onUpdateUnit={unitActions.saveUnit}
      />
    )
  }
}

export default connect(UnitAdminContainer.mapStateToProps, UnitAdminContainer.mapDispatchToProps)(UnitAdminContainer)
